/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Read_Error_ToastInputs */



/**
* | output |
* | --- |
* | "Error reading file" |
*
* @param {Plain_Text_Import_Read_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_read_error_toast = /** @type {((inputs?: Plain_Text_Import_Read_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Read_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur de lecture du fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Lesen der Datei")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore durante la lettura del file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка при чтении файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al leer el archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("读取文件时出错")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルの読み取りエラー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल पढ़ने में त्रुटि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro ao ler o arquivo")
	return /** @type {LocalizedString} */ ("Error reading file")
});